import React, {useEffect, useState} from 'react';
import {CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import api from '../../../../api/axios';
import Cookies from 'js-cookie';

const WeeklyCompareChart = () => {
    const [lineColorAG, setLineColorAG] = useState('#8884d8');
    const [lineColorVG, setLineColorVG] = useState('#82ca9d');
    const [chartData, setChartData] = useState([]);
    const [yAxisDomain, setYAxisDomain] = useState([0, 'auto']);

    useEffect(() => {
        const getCSSBackgroundColor = (className) => {
            const element = document.createElement('div');
            element.className = className;
            document.body.appendChild(element);
            const bgColor = window.getComputedStyle(element).backgroundColor;
            document.body.removeChild(element);
            return bgColor;
        };

        const agColor = getCSSBackgroundColor('bg-color-1');
        const vgColor = getCSSBackgroundColor('bg-color-4');

        setLineColorAG(agColor);
        setLineColorVG(vgColor);

        const fetchProjectData = async () => {
            try {
                const accessToken = Cookies.get('accessToken');

                const response = await api.get('/api/v1/project/stats/occurrence', {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                const {pastProjectOccurrence, currentProjectOccurrence} = response.data;

                const transformedData = Object.keys(currentProjectOccurrence).map((key, index) => {
                    const currentProjects = currentProjectOccurrence[key]?.projects || 0;
                    const pastKey = Object.keys(pastProjectOccurrence)[index];
                    const pastProjects = pastProjectOccurrence[pastKey]?.projects || 0;

                    return {
                        id: index + 1,
                        name: `${index + 1}`,
                        AG: currentProjects,
                        VG: pastProjects,
                    };
                });

                setChartData(transformedData);

                const allValues = transformedData.flatMap((d) => [d.AG, d.VG]);
                const minValue = Math.min(...allValues);
                const maxValue = Math.max(...allValues);

                // Anpassung der Y-Achse: 10% unter und 10% über dem Wertebereich, dann auf ganze Zahlen runden
                const padding = (maxValue - minValue) * 0.2;
                const roundedMin = Math.floor(minValue - padding);
                const roundedMax = Math.ceil(maxValue + padding);
                setYAxisDomain([roundedMin, roundedMax]);
            } catch (error) {
                console.error('Fehler beim Abrufen der Projektdaten:', error);
            }
        };

        fetchProjectData();
    }, []);

    const CustomTooltip = ({active, payload}) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip bg-color-3 rounded-lg p-2 opacity-90 border border-color-1"
                     style={{marginTop: '-80px'}}>
                    <p>{`Woche: ${payload[0].payload.name}`}</p>
                    <p>{`Aktueller Zeitraum: ${payload[0].value.toLocaleString('de-DE')}`}</p>
                    {payload[1] && <p>{`Vorheriger Zeitraum: ${payload[1].value.toLocaleString('de-DE')}`}</p>}
                </div>
            );
        }
        return null;
    };

    return (
        <div className='w-full h-full flex items-center justify-center pt-14 pb-2'>
            <ResponsiveContainer width="100%" height={160}>
                <LineChart margin={{top: 5, right: 25, left: -25, bottom: 0}} data={chartData}>
                    <CartesianGrid vertical={false} horizontal={false}/>
                    <XAxis dataKey="name"/>
                    <YAxis
                        domain={yAxisDomain}
                        tickFormatter={(value) => Math.round(value)} // Werte auf ganze Zahlen runden
                    />
                    <Tooltip content={<CustomTooltip/>} cursor={0}/>
                    <Line type="monotone" strokeWidth={2.5} dataKey="AG" stroke={lineColorAG}
                          name="Aktueller Zeitraum"/>
                    <Line type="monotone" strokeWidth={2.5} dataKey="VG" stroke={lineColorVG}
                          name="Vorheriger Zeitraum"/>
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default WeeklyCompareChart;
